/**
 * Subscription offer config — single source for Subscribe & Save copy and
 * the default state of the subscribe toggle (cart, BYO panel, mobile drawer).
 * Oct 2026: nothing about the offer is hard-coded in components; the admin
 * offer config from the main brief will replace these literals when it ships.
 */
import { WAGYU_BURGER_VALUE } from "@/config/subscriptionConfig";

export const OFFER = {
  subscriberDiscountPct: 5,
  burgerPerk: true,
  burgerValue: WAGYU_BURGER_VALUE,
  subscribeDefaultOn: true,
};

export const perkLine = () =>
  OFFER.burgerPerk ? `Free Wagyu burgers · $${OFFER.burgerValue} value` : "";

export const savingsLine = () =>
  `${OFFER.subscriberDiscountPct}% off · skip, pause or cancel anytime`;

export const subscribeShortLine = () =>
  [`Save ${OFFER.subscriberDiscountPct}%`, OFFER.burgerPerk ? "free Wagyu burgers" : ""].filter(Boolean).join(" + ");
